import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { FIELD_MAX_HEIGHT, ELEMENT_MAX_WIDTH } from 'styles';
import { DEEP_BORDER_BOX } from 'common';

export default {
  Wrapper: styled.div`
    ${DEEP_BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    flex-direction: column;
    width: 100%;
    ${props => props.maxWidth ? css`
      max-width: ${ELEMENT_MAX_WIDTH};
    ` : css`
      max-width: 100%;
    `}
  `,
  RowWrapper: styled.div`
    display: flex;
    width: 100%;
    position: relative;
  `,
  FieldWrapper: styled.div`
    position: relative;
    width: 100%;
    & input {
      caret-color: ${props => props.theme.caret};
    }
  `,
  ErrorContainer: styled.div`
    max-height: ${FIELD_MAX_HEIGHT};
    width: 100%;
    max-width: 100%;
    margin-top: ${Tokens.SPACING.SPACING_4};
  `
};